export default __webpack_public_path__ + "static/media/s3_female.fa439cc3.wav";